import * as React from "react"
import authenticWalton from "images/AuthenticWaltonLogo.svg"
import keepWCBeautiful from "images/KeepWCBeautifulColorLogo.svg"
import southWalton from "images/SouthWaltonLogo.svg"

import Image from 'components/Image'
import Link from "components/Link"

const FooterLogos = () => {
    return (
        <div className="footer-logos-container">
            <div className="grid-container">
                <div className="grid-x grid-padding-x align-center align-middle" style={{display: 'flex', justifyContent: 'center'}}>
                    <div className="cell small-12 medium-4 footer-logo">
                        <Link to={'https://www.authenticwalton.com/'} style={{display: 'flex', justifyContent: 'center'}}>
                            <Image className="image" src={authenticWalton} alt={"Authnetic Walton Logo"} style={{ height: '97px' }} />
                        </Link>
                    </div>
                    <div className="cell small-12 medium-4 footer-logo">
                        <Link to={'https://www.keepwaltoncountybeautiful.org/'} style={{display: 'flex', justifyContent: 'center'}}>
                            <Image className="image" src={keepWCBeautiful} alt={"Keep Walton County Beautiful Logo"} style={{ width: '171px' }} />
                        </Link>
                    </div>
                    <div className="cell small-12 medium-4 footer-logo third">
                        <Link to={'https://visitsouthwalton.com/'} style={{display: 'flex', justifyContent: 'center'}}>
                            <Image className="image" src={southWalton} alt={"South Walton Logo"} style={{ height: '115px' }} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterLogos;
